import React from 'react';
import { hasBetterNav } from 'Components/UI/Navigation/Schema/advisor';
import NavigationSkeleton from './NavigationSkeleton';

const Loading = () => {
  if (hasBetterNav(window)) {
    return null;
  }
  return (
    <NavigationSkeleton />
  );
};

export default Loading;
